// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_WXgFSRMmSAnKdIqF-yn6"};